import React from 'react';
import rehypeReact from 'rehype-react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Container from '../components/Container';
import NewsletterForm from '../components/NewsletterForm';

const renderAst = new rehypeReact({
  createElement: React.createElement,
}).Compiler;

const Post = ({
  data: {
    markdownRemark: {
      htmlAst,
      frontmatter: { title, description, path },
    },
  },
}) => (
  <Layout
    seo={{
      title,
      description,
      thumbnail: `/blog-thumbnails/${path.replace('/', '')}.png`,
    }}
  >
    <Container>
      {renderAst(htmlAst)}
      <NewsletterForm />
    </Container>
  </Layout>
);

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        title
        description
        path
      }
    }
  }
`;

export default Post;
